import React, { useEffect, useState, useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import orderBy from 'lodash/orderBy';

import { useTranslation } from 'react-i18next';

// Provider
import ModeContext from '../../context/ModeContext';
import UserContext from '../../context/UserContext';

// icon
import { DamIcon } from '../../assets/svg/Icon';

// components
import DamLists from './lists/latest/DamLists';
import Map from './map';
import DamLegend from './legend/DamLegend';
import NavForm from './formcontrol/FormControl';

// style
import './styles.css';
import { globalStyle } from '../../global/style';

const useStyles = makeStyles(globalStyle);

export default function Main() {
  const { t } = useTranslation();
  const classes = useStyles();

  // const [keyword, setKeyword] = useState('');
  const [error, setError] = useState('');
  const [datasLargeDam, setLargeDamData] = useState([]);
  const [datasMediumDam, setMediumDamData] = useState([]);
  const [map, setMap] = useState(null);
  const [markers] = useState([]);

  // get context
  const { currentMode, currentArea } = useContext(ModeContext);
  const { userIsLogin } = useContext(UserContext);

  // get map reference and set to state
  const handleSetMap = (mapRef) => {
    setMap(mapRef);
  };

  // link table to marker
  const handleSearchMarker = (id, lat, lng) => (e) => {
    // prevent default action
    e.preventDefault();

    // pan map to current marker position
    map.panTo([parseFloat(lat), parseFloat(lng)]);

    // open Popup
    const currentMarker = markers[id];
    if (currentMarker) {
      currentMarker.openPopup();
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      fetch(`${process.env.REACT_APP_API_URL}/analyst/dam`)
        .then((response) => {
          if (response.ok) {
            return response.json();
          }
          throw new Error('Something went wrong ...');
        })
        .then((result) => {
          // set up last 24 hrs time
          const currentDateTime = new Date();
          const last24hrs = currentDateTime.setDate(currentDateTime.getDate() - 2);

          /*
          Add filter by province or basin later
          */
          // large dam, filter null and data not updated in 24 hrs
          const damDailySort = orderBy(result.data.dam_daily, ['dam_storage_percent'], ['desc']);
          const datasDamLatest = damDailySort.filter((d) => {
            const time = new Date(d.dam_date).getTime();
            return (
              ((last24hrs < time) && (d.agency.id === 12)) || ([231, 319, 320].includes(d.dam.id))
            );
          });

          // medium dam, filter null and data not updated in 24 hrs,
          // and normal_storage < 2 millions (onwr requirement)
          // if data is null convert to '' so data will order Null Last
          const damMediumSort = orderBy(result.data.dam_medium, [(o) => o.dam_storage_percent || ''], ['desc']);
          const datasDamMedium = damMediumSort.filter((d) => {
            const time = new Date(d.dam_date).getTime();

            return (last24hrs < time || d.dam_date === '1970-01-01');
            // return (last24hrs < time && d.dam.normal_storage > 2);
          });

          // set data state
          setLargeDamData(datasDamLatest);
          setMediumDamData(datasDamMedium);
        })
        .catch((err) => setError(err));
    };

    fetchData();
  }, []);

  return (
    <div className={classes.root}>
      {error && <div>Error Occured</div>}

      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={4}>
          <Box display="flex" alignItems="center">
            <Box display="flex" className={classes.shapeCircle} alignItems="center" justifyContent="center">
              <DamIcon style={{ color: 'white' }} />
            </Box>
            <Box p={1}><Typography variant="h6" className={classes.titlePage}>{t('แหล่งน้ำ')}</Typography></Box>
          </Box>
          <Box>
            <Map
              markers={markers}
              datasLargeDam={datasLargeDam}
              datasMediumDam={datasMediumDam}
              handleSetMap={handleSetMap}
              currentMode={currentMode}
              currentArea={currentArea}
            />
            <DamLegend />
          </Box>
        </Grid>
        <Grid item xs={12} sm={12} md={8}>
          <NavForm />
          <Box mt={3}>
            <DamLists
              datasLargeDam={datasLargeDam}
              datasMediumDam={datasMediumDam}
              handleSearchMarker={handleSearchMarker}
              currentMode={currentMode}
              currentArea={currentArea}
              userIsLogin={userIsLogin}
            />
          </Box>
        </Grid>
        <Grid container justifyContent="flex-end">
          {t('ข้อมูลจาก สทนช และกรมชลประทาน')}
        </Grid>
      </Grid>
    </div>
  );
}
